module.exports = __webpack_public_path__ + "img/Ansturm.8b3a0aa0.jpg";